export class HtmlHelper {
	public persistantNotification(options): HTMLElement {
		if (options === 'clearAll') {
			document.querySelector('.VisibaPersistantNotificationWrap').remove();
			return null;
		}

		const div = document.createElement('div');
		div.className = 'VisibaPersistantNotificationWrap';
		div.innerHTML = `
      <div class="VisibaPersistantNotification">
         <div class="title">${options.Title}</div>
         <div class="description">${typeof options.Description === 'undefined' ? '' : options.Description}</div>
      </div>`;
		document.body.appendChild(div);

		return div;
	}

	public loading(action: 'show' | 'hide') {
		const elem = document.querySelector('#contentLoading') as HTMLElement;

		if (action === 'show') {
			if (elem === null) {
				const div = document.createElement('div');
				div.id = 'contentLoading';
				div.innerHTML = '<img class="inner" src="/Images/ajax-loader-squares.gif" alt="Loading" />';
				document.body.appendChild(div);
			}

			if (!elem) return;
			if (elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length) return false;

			elem.style.display = 'block';
		} else {
			elem.style.display = 'none';
		}
	}

	public loadJavascript(src, callback) {
		const script = document.createElement('script');
		let loaded = false;

		script.src = src;
		if (callback) {
			script.onload = script.onload = () => {
				if (!loaded) {
					callback();
				}
				loaded = true;
			};
		}
		document.head.appendChild(script);
	}

	/**
	 * Strips all HTML in text while still leaving things like heart symbols that uses < >
	 */
	public stripHtml(input: string): string {
		return new DOMParser().parseFromString(input, 'text/html').body.textContent;
	}
}
